import WebFont from 'webfontloader';

function loadFont(font) {
  return new Promise((resolve) => {
    WebFont.load({
      google: {
        families: [font],
      },

      fontactive: function() {
        resolve(font);
      },
    });
  })
}

export default loadFont
